var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYesNo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.6 139.854 16 16",
    enableBackground: "new 78.6 139.854 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M82.666,145.759l-1.546-1.546l-0.707,0.707l2.253,2.253l4.204-4.204l-0.707-0.707L82.666,145.759z  M88.02,152.819l1.572-1.571l1.572,1.571l0.707-0.707l-1.572-1.571l1.572-1.572l-0.707-0.707l-1.572,1.572l-1.572-1.572 l-0.707,0.707l1.572,1.572l-1.572,1.571L88.02,152.819z M88.6,145.854v-6h-10v10h6v6h10v-10H88.6z M84.6,148.854h-5v-8h8v5h-3 V148.854z M93.6,154.854h-8v-8h8V154.854z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYesNo01);
export default __webpack_public_path__ + "static/media/icon_yes_no-01.28909bb2a0afb64c051de421ff2b949c.svg";
export { ForwardRef as ReactComponent };